import { Component, Injector, Input } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';

import { ITotal } from '@app/activo2/vacations/components/total-vacations/total-vacations.interface';
import { TotalVacationsDetailModalComponent } from '@app/activo2/vacations/components/total-vacations-detail-modal/total-vacations-detail-modal.component';
import { ModalManager } from '@app/services';
import { AnalyticsService } from '@app/services/analytics/analytics.service';
import { ActionsAnalytics, CategoriesAnalytics } from '@app/services/analytics/models/analytics.enum';
import { BaseComponentDirective } from '@app/shared/bases/base.component';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

@Component({
  selector: 'app-total-vacations',
  templateUrl: './total-vacations.component.html',
  styleUrls: ['./total-vacations.component.scss']
})
export class TotalVacationsComponent extends BaseComponentDirective {
  @Input() totals!: ITotal[];
  @Input() isMomoUser!: boolean;

  constructor(injector: Injector, private modalManager: ModalManager, private analyticsService: AnalyticsService) {
    super();
  }

  async openDetailTotalVacations(isSection: boolean, event: Event) {
    event.stopImmediatePropagation();

    if (isSection) return;
    this.sendAnalyticsEvent();
    this.openDetailInModal();
  }

  trackByItems(item: ITotal) {
    return item;
  }

  protected sendAnalyticsEvent() {
    this.analyticsService.sendEvent(CategoriesAnalytics.CLICK, {
      [ActionsAnalytics.CLICKACTION]: ActionsAnalytics.MORE_INFO
    });
  }

  private openDetailInModal(): Promise<MSafeAny> {
    const modalOptions: MatDialogConfig = {
      panelClass: ['media-content-modal', 'mot-day-detail-modal']
    };

    return this.modalManager.openMatModal(TotalVacationsDetailModalComponent, modalOptions);
  }
}
